// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LevelButton-module__levelName__1p66-{font-size:1em}.LevelButton-module__levelDescription__1EXny{font-size:0.7em}.LevelButton-module__geneNumber__3c-Jr{font-size:0.8em}.btn.LevelButton-module__levelButton__FH9Ub{border:1px solid #d3d3d3;background-color:white;border-radius:0.5rem;width:100%;font-size:1.2rem}.btn.LevelButton-module__levelButtonLink__2cvNs{border:0;background-color:white;width:100%;font-size:1.6rem;font-weight:700}.btn.LevelButton-module__levelButtonLink__2cvNs:hover{background-color:white}\n", ""]);
// Exports
exports.locals = {
	"levelName": "LevelButton-module__levelName__1p66-",
	"levelDescription": "LevelButton-module__levelDescription__1EXny",
	"geneNumber": "LevelButton-module__geneNumber__3c-Jr",
	"levelButton": "LevelButton-module__levelButton__FH9Ub",
	"levelButtonLink": "LevelButton-module__levelButtonLink__2cvNs"
};
module.exports = exports;
